import { com } from '@eidu/web'
import EntityTypeKind = com.eidu.entity.type.EntityTypeKind
import entityTypeKindFromString = com.eidu.entity.type.entityTypeKindFromString

// Keep in sync with EntityTypeKind.wellKnown (defined in Kotlin backend)
type WellKnownKindKey =
  | 'User'
  | 'School'
  | 'Generic'
  | 'LearningUnit'
  | 'Form'
  | 'Dataset'
  | 'Config'
  | 'Configuration'
  | 'Runtime'
  | 'Asset'
export const consoleDefinedKindKeys = ['Chart', 'Dashboard', /**@deprecated*/ 'Feature'] as const
export type ConsoleDefinedKindKey = (typeof consoleDefinedKindKeys)[number]
export type KnownKindKey = WellKnownKindKey | ConsoleDefinedKindKey

export type SidebarGroup = 'administration' | 'entity' | 'document' | 'asset'

type KindDefinition = {
  kind: EntityTypeKind
  label: string
  sidebarSectionId: string
  sidebarGroup: SidebarGroup
}

export const kindDefinitions = {
  User: { kind: EntityTypeKind.Companion.User, label: 'Users', sidebarSectionId: 'users', sidebarGroup: 'entity' },
  School: {
    kind: EntityTypeKind.Companion.School,
    label: 'Schools',
    sidebarSectionId: 'schools',
    sidebarGroup: 'entity',
  },
  Generic: {
    kind: EntityTypeKind.Companion.Generic,
    label: 'Others',
    sidebarSectionId: 'others',
    sidebarGroup: 'entity',
  },
  LearningUnit: {
    kind: EntityTypeKind.Companion.LearningUnit,
    label: 'Learning Units',
    sidebarSectionId: 'learning-units',
    sidebarGroup: 'document',
  },
  Form: {
    kind: EntityTypeKind.Companion.Form,
    label: 'Forms',
    sidebarSectionId: 'forms',
    sidebarGroup: 'asset',
  },
  Dataset: {
    kind: EntityTypeKind.Companion.Dataset,
    label: 'Datasets',
    sidebarSectionId: 'datasets',
    sidebarGroup: 'asset',
  },
  Chart: {
    kind: entityTypeKindFromString('Chart'),
    label: 'Charts',
    sidebarSectionId: 'charts',
    sidebarGroup: 'asset',
  },
  Dashboard: {
    kind: entityTypeKindFromString('Dashboard'),
    label: 'Dashboards',
    sidebarSectionId: 'dashboards',
    sidebarGroup: 'asset',
  },
  Runtime: {
    kind: EntityTypeKind.Companion.Runtime,
    label: 'Runtimes',
    sidebarSectionId: 'runtimes',
    sidebarGroup: 'asset',
  },
  /** @deprecated */
  Feature: {
    kind: entityTypeKindFromString('Feature'),
    label: 'Features',
    sidebarSectionId: 'features',
    sidebarGroup: 'asset',
  },
  /** @deprecated replaced by Configuration */
  Config: {
    kind: EntityTypeKind.Companion.Config,
    label: 'Configs',
    sidebarSectionId: 'configs',
    sidebarGroup: 'asset',
  },
  Configuration: {
    kind: EntityTypeKind.Companion.Configuration,
    label: 'Configurations',
    sidebarSectionId: 'configurations',
    sidebarGroup: 'administration',
  },
  Asset: {
    kind: entityTypeKindFromString('Asset'),
    label: 'Assets',
    sidebarSectionId: 'assets',
    sidebarGroup: 'asset',
  },
} satisfies Record<KnownKindKey, KindDefinition>

const kindToKeyMap = new Map(
  (Object.entries(kindDefinitions) as [KnownKindKey, KindDefinition][]).map(([key, def]) => [def.kind.toString(), key])
)

export const getKnownKindKey = (kind: EntityTypeKind): KnownKindKey | undefined => kindToKeyMap.get(kind.toString())

export const knownKinds: readonly EntityTypeKind[] = Object.values(kindDefinitions).map((d) => d.kind)
